<script setup lang="ts">
import { fetchPublicData } from '~~/services/CompanyServices'

definePageMeta({
  middleware: 'public',
  layout: 'consumer',
})

const { data, error } = await useLazyAsyncData(() =>
  fetchPublicData(useRoute().params.companySlug as string)
)

const companyName = computed(
  () => data?.value?.data?.company?.name || 'Company'
)

usePageMeta({
  name: 'OpenESG',
  title: `${companyName.value} OpenESG Sustainability ID`,
  description: `Find out the real ESG result for ${companyName.value}`,
})
</script>
<template lang="pug">
div
  div(v-if="error" class="container")
    PageTitlePublic
      template(#title) Error fetching company.
  div(v-if="data" class="w-full")
    div(class="container")
      PageTitlePublic(
        v-if="data.data.company"
        :company="data.data.company"
      )
        template(#tools)
          ResultVerifiedBadge(
            :hasVerifiedScore="!!data.data.result.verified_at"
          )

      div(
        v-if="data.data.result"
        class="flex flex-col lg:grid lg:grid-cols-3 gap-18 md:gap-36"
      )
        div(class="col-span-1")
          div(
            class="sticky top-120 flex flex-col md:grid md:grid-cols-2 lg:flex gap-12"
          )
            ResultBreakdown(
              :is-public="true"
              :survey-response="data.data.result"
              :is-verified="!!data.data.result.verified_at"
              :image-url="data.data.company.logo_url"
            )

            MetadataCompany(
              class="hidden md:flex"
              :company="data.data.company"
              :survey-response="data.data.result"
              :verified="data.data.result.verified_at || ''"
            )
        div(class="col-span-2")
          ResultPublicList(:metrics="data.data.metrics")
          MetadataCompany(
            class="md:hidden"
            :company="data.data.company"
            :survey-response="data.data.result"
          )

      //- pre {{ data }}
</template>
